var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.classes},_vm._l((3),function(i){return _c('span',{key:i,staticClass:"cordel-loading-bullet"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }